module.exports = __webpack_public_path__ + "img/Sale-Details.8ed8525d.jpg";